const broadcast = (componentName, eventName, params) => {
  this.$children.forEach(child => {
    const name = child.$options.name
    if (name === componentName) {
      child.$emit.apply(child, [eventName].concat(params))
    } else {
      broadcast.apply(child, [componentName, eventName])
    }
  })
}

export default {
  methods: {
    dispatch(componentName, eventName, params, appComponent = false) {
      let parent = this.$parent || this.$root
      let name = parent.$options.name
      if (appComponent !== false) {
        parent = parent.$root.$children[0]
        const vApp = parent?.$children?.find(
          el => el.$options._componentTag === 'v-app',
        )
        if (vApp) {
          parent = vApp

          const globalComponent = parent?.$children?.find(
            el => el.$options._componentTag === appComponent,
          )

          parent = globalComponent
          name = parent?.$options?.name
        }
      } else {
        while (parent && (!name || name !== componentName)) {
          parent = parent.$parent
          if (parent) {
            name = parent.$options.name
          }
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params))
      }
    },

    broadcast(componentName, eventName, params) {
      broadcast.call(this, componentName, eventName, params)
    },
  },
}
